import { cloneDeep } from "lodash";
import { REACT_APP_DB_NAME } from "../../env";

export const FUND_PARSE_JOB_NAME = "ExtTptFileConsolidator";

export const FUND_PARSE_DATE_HELP =
    "Valuation date for the job. Use YYYY-MM-DD (e.g. 2025-01-31), or one of: today, yesterday, previous, previousmonth.";

export interface FundParseFormValues {
    database: string;
    date: string;
    client_id: string;
    position_client_ids: string[];
    create_report: boolean;
    save_report: boolean;
    read_report: boolean;
    create_report_xlsx: boolean;
    create_esg_input_xlsx: boolean;
    create_lookthrough_csvs: boolean;
}

export const FUND_PARSE_DEFAULT_FORM_VALUES: FundParseFormValues = {
    database: "prod",
    date: "previousmonth",
    client_id: "",
    position_client_ids: [],
    create_report: false,
    save_report: false,
    read_report: true,
    create_report_xlsx: false,
    create_esg_input_xlsx: false,
    create_lookthrough_csvs: true
};

export function getInitialFundParseFormValues(): FundParseFormValues {
    const defaults = cloneDeep(FUND_PARSE_DEFAULT_FORM_VALUES);
    if (REACT_APP_DB_NAME === "test" || REACT_APP_DB_NAME === "prod") {
        defaults.database = REACT_APP_DB_NAME;
    }
    return defaults;
}
